// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"f39ac866","12":"818b9afc","23":"cfe67d1e","87":"9d52eb38","121":"9945d81a","163":"16460d5c","251":"1a4ffae7","256":"25a4a499","460":"e92cc32f","693":"b2b1ecef","767":"d1031dae"}[chunkId] + ".chunk.js";
};